<template>
  <span>
    <strong v-if="annotationText" class="text">{{ annotationText }}</strong>
  </span>
</template>

<script>

export default {
  name: 'AnnotationLabel',
  props: ['isIntro', 'stateAnnotations', 'latestDistrictCode', 'numDistricts', 'totalTimelineSpan'],
  computed: {
    districtName () {
      // catch at-large districts and territories
      if (this.latestDistrictCode === 0 || this.latestDistrictCode === 98) {
        return 'at-large';
      }
      return this.numberWithOrdinalSuffix(this.latestDistrictCode);
    },
    annotationText () {
      if (!this.stateAnnotations) return null;

      let strong_text = '';

      if (this.numDistricts > 1) {
        if (this.isIntro) {
          strong_text = `Let’s look at the history of `;
        }
        else {
          const today = new Date().getFullYear();
          strong_text = this.totalTimelineSpan.end >= today ? 'Today' : 'As of ' + this.totalTimelineSpan.end;
          strong_text += `, this is `;
        }
        strong_text += `${this.stateAnnotations.name}’s ${this.districtName} district.`;
      } else {
        strong_text += `This is ${this.stateAnnotations.name}’s ${this.districtName} district.`;
      }

      return strong_text;
    }
  },
  methods: {
    numberWithOrdinalSuffix (i) {
      // via https://stackoverflow.com/a/13627586
      const j = i % 10;
      const k = i % 100;
      if (j == 1 && k != 11) {
          return i + "st";
      }
      if (j == 2 && k != 12) {
          return i + "nd";
      }
      if (j == 3 && k != 13) {
          return i + "rd";
      }
      return i + "th";
    }
  }
}

</script>

<style lang="scss" scoped>
.mq-mobile {
  p {
      margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AnnotationLabel.vue